import { useNavigate } from 'react-router-dom';
import { mockTools } from './data/mockTools';


export const RelatedTools = ({ currentTool }) => {
  const navigate = useNavigate();

  // Find related tools based on category and tags
  const relatedTools = mockTools
    .filter(tool => 
      tool.id !== currentTool.id && (
        tool.category === currentTool.category ||
        tool.tags.some(tag => currentTool.tags.includes(tag))
      )
    )
    .slice(0, 3); // Show only 3 related tools

  if (relatedTools.length === 0) {
    return null;
  }

  return (
    <div className="related-tools">
      <div className="related-tools-header">
        <h2>Related Tools</h2>
        <a 
          href={`/marketplace?category=${currentTool.category}`}
          className="view-all-button"
          onClick={(e) => {
            e.preventDefault();
            navigate(`/business-tool-marketplace/marketplace?category=${currentTool.category}`);
          }}
        >
          View All
        </a>
      </div>

      <div className="tools-grid">
        {relatedTools.map(tool => (
          <div key={tool.id} className="tool-card">
            {tool.imageUrl && (
              <img 
                src={tool.imageUrl} 
                alt={tool.title} 
                className="tool-image"
                onClick={() => navigate(`/business-tool-marketplace/tool/${tool.id}`)}
              />
            )}
            <div className="tool-content">
              <h3 
                className="tool-title"
                onClick={() => navigate(`/business-tool-marketplace/tool/${tool.id}`)}
              >
                {tool.title}
              </h3>
              <p className="tool-description">{tool.description}</p>
              <div className="tool-meta">
                <span className="tool-category">{tool.category}</span>
                <span className="tool-price">
                  {tool.price === 0 ? 'Free' : `$${tool.price.toFixed(2)}`}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}; 